import React from "react";
import { AdminApolloClient } from "../context/AdminApolloClient";

export const useAdminApolloClient = () => React.useContext(AdminApolloClient);
